import React from "react";

import { useTranslation } from "react-i18next";

import { DoubleChance } from "@data-types/sport-stats/SportStatsTypes";
import RecentGames from "../RecentGames";

import Graph from "../Graph";

export default function DoubleChanceStatistics(props: {
	homeTeam: DoubleChance["data"];
	awayTeam: DoubleChance["data"];
}) {
	const { t } = useTranslation();

	return (
		<>
			<RecentGames
				homeTeamEventCount={props.homeTeam?.eventCount}
				awayTeamEventCount={props.awayTeam?.eventCount}
			/>

			<Graph
				title={t(
					"EVENT.STATISTICS.BETTING_TYPE_STATS.GAMES_WON_OR_DRAWN"
				)}
				home={t("OFFER.COMPETITORS.HOME")}
				away={t("OFFER.COMPETITORS.AWAY")}
				graphName={t("BETTING_TYPE.DOUBLE_CHANCE")}
				data={{
					homeValue: props.homeTeam?.gamesWonOrDrawn,
					awayValue: props.awayTeam?.gamesWonOrDrawn,
				}}
				isPercentage
			/>
		</>
	);
}
